export const systemRoleEnum = {
  SUPER_ADMIN: "SUPER_ADMIN",
  COORDINATOR: "COORDINATOR",
  ENTREPRENEUR: "ENTREPRENEUR",
  ADVISER: "ADVISER"
};
